import { ConciergeBehaviorSettingsParser } from "@redotech/redo-concierge-settings-common/general";
import { object, string } from "zod";
import { UrlArraySchema } from "../common/url-parser";

export const generateConciergeBehavior = {
  name: "generateConciergeBehavior" as const,
  input: object({ text: string().max(100_000), urls: UrlArraySchema }),
  output: ConciergeBehaviorSettingsParser,
};
